export interface ISummationMode {
  value: string;
  displayName: string;
}

// Summerar per journal
interface IJournalSummationMode extends ISummationMode {
  value: 'journal';
  displayName: 'Journal';
  backendValue: 2;
}
export const journalSummationMode: IJournalSummationMode = {
  value: 'journal',
  displayName: 'Journal',
  backendValue: 2,
};

// Summerar per verifikation
interface IVerifikationSummationMode extends ISummationMode {
  value: 'verifikation';
  displayName: 'Verifikation';
  backendValue: 1;
}
export const verifikationSummationMode: IVerifikationSummationMode = {
  value: 'verifikation',
  displayName: 'Verifikation',
  backendValue: 1,
};

// Summerar per verifikationsrad (Ingen summering)
interface IVerifikationsradSummationMode extends ISummationMode {
  value: 'verifikationsrad';
  displayName: 'Verifikationsrad';
  backendValue: 0;
}
export const verifikationsradSummationMode: IVerifikationsradSummationMode = {
  value: 'verifikationsrad',
  displayName: 'Verifikationsrad',
  backendValue: 0,
};

export const defaultSummationMode = verifikationSummationMode;

export type SummationModeType =
  | IJournalSummationMode
  | IVerifikationsradSummationMode
  | IVerifikationSummationMode;

export const summationModes: ISummationMode[] = [
  journalSummationMode,
  verifikationSummationMode,
  verifikationsradSummationMode,
];

const isSummationModeType = (
  maybeSummationMode: ISummationMode
): maybeSummationMode is SummationModeType =>
  maybeSummationMode.value === journalSummationMode.value ||
  maybeSummationMode.value === verifikationSummationMode.value ||
  maybeSummationMode.value === verifikationsradSummationMode.value;

export const getSummationModeOrDefault = (
  value: string | null
): SummationModeType => {
  if (value && isSummationModeType({ displayName: '', value })) {
    if (value === journalSummationMode.value) {
      return journalSummationMode;
    } else if (value === verifikationSummationMode.value) {
      return verifikationSummationMode;
    } else if (value === verifikationsradSummationMode.value) {
      return verifikationsradSummationMode;
    }
  }

  return defaultSummationMode;
};

interface IBudgetVerifikationSummationMode extends ISummationMode {
  value: 'budgetVerifikation';
  displayName: 'Budgetverifikation';
  backendValue: 0;
}

export const budgetVerifikationSummationMode: IBudgetVerifikationSummationMode =
  {
    value: 'budgetVerifikation',
    displayName: 'Budgetverifikation',
    backendValue: 0,
  };

interface IBudgetRadSummationMode extends ISummationMode {
  value: 'budgetRad';
  displayName: 'Budgetrad';
  backendValue: 1;
}

export const budgetRadSummationMode: IBudgetRadSummationMode = {
  value: 'budgetRad',
  displayName: 'Budgetrad',
  backendValue: 1,
};

export const defaultBudgetSummationMode = budgetRadSummationMode;

export type BudgetSummationModeType =
  | IBudgetVerifikationSummationMode
  | IBudgetRadSummationMode;

const isBudgetSummationModeType = (
  maybeSummationMode: ISummationMode
): maybeSummationMode is BudgetSummationModeType =>
  maybeSummationMode.value === budgetRadSummationMode.value ||
  maybeSummationMode.value === budgetVerifikationSummationMode.value;

export const getBudgetSummationModeOrDefault = (
  value: string | null
): BudgetSummationModeType => {
  if (value && isBudgetSummationModeType({ displayName: '', value })) {
    if (value === budgetRadSummationMode.value) {
      return budgetRadSummationMode;
    } else if (value === budgetVerifikationSummationMode.value) {
      return budgetVerifikationSummationMode;
    }
  }
  return defaultBudgetSummationMode;
};
